export const Defaults = {
  ACCESS_TOKEN_COOKIE_KEY: 'accessToken',
  REFRESH_TOKEN_COOKIE_KEY: 'refreshToken',
  APPSTORE_LINK: 'https://apps.apple.com/us/app/schoolyard-social/id6749558108',
  PLAYSTORE_LINK: 'https://play.google.com/store/apps/details?id=co.schoolyardsocial.schoolyard.prod',
};
